export default function Game(p)
{
	const PIECE_WIDTH = 100;
	const PIECE_HEIGHT = 100;
	const PIECE_SPACING = 5;
	const PIECE_TEXT_SIZE = 64;

	const TITLE_HEIGHT = 40;

	const BOARD_WIDTH = ((PIECE_WIDTH + PIECE_SPACING) * 3) + PIECE_SPACING;
	const BOARD_HEIGHT = ((PIECE_HEIGHT + PIECE_SPACING) * 3) + PIECE_SPACING + TITLE_HEIGHT;

	const GAME_STATE_MENU = 1;
	const GAME_STATE_PLAYING = 2;
	const GAME_STATE_FINISHING = 3;
	const GAME_STATE_FINISHED = 4;

	const AI_NONE = 0;
	const AI_DIFFICULTY_EASY = 1;
	const AI_DIFFICULTY_MEDIUM = 2;
	const AI_DIFFICULTY_HARD = 3;

	const PLAYER_ONE = 1;
	const PLAYER_TWO = 2;
	const PLAYER_TIE = 3;

	const ANIMATION_TIME = 750;
	const ANIMATION_BUFFER = 1250;

	const BOARD_PIECES = ['X', 'O'];

	let boardPieces = [[], [], []];
	let gameState;
	let playersTurn;
	let currentTurn;
	let gameWinner;
	let aiDifficulty;
	let animationStart;

	p.setup = function()
	{
		p.createCanvas(BOARD_WIDTH, BOARD_HEIGHT);
		gameState = GAME_STATE_MENU;
		playersTurn = PLAYER_ONE;
		currentTurn = 0;
		gameWinner = -1;
		aiDifficulty = AI_NONE;
		
		for(let i = 0; i < 3; i++)
		{
			for(let j = 0; j < 3; j++)
			{
				boardPieces[i][j] = ' ';
			}
		}
	};

	p.draw = function()
	{
		p.background(47, 47, 47);
	
		p.fill(255, 255, 255);
		
		p.stroke(0, 0, 0);
		p.strokeWeight(0);

		if(gameState === GAME_STATE_MENU)
		{
			// AI
			p.fill(255, 255, 255);
			p.text("2 player hotseat", (BOARD_WIDTH - p.textWidth("2-player hotseat")) / 2, PIECE_SPACING + 25);

			// Button: Play
			p.rect(PIECE_SPACING, PIECE_SPACING + (PIECE_SPACING + 25) + 10, BOARD_WIDTH - (PIECE_SPACING * 2), 40);
			
			p.fill(0, 0, 0);
			p.textSize(16);
			p.text("Play", (BOARD_WIDTH - p.textWidth("Play")) / 2, PIECE_SPACING + 25 + (PIECE_SPACING + 25) + 10);
			
			// AI
			p.fill(255, 255, 255);
			p.text("Versus AI", (BOARD_WIDTH - p.textWidth("Versus AI")) / 2, 120);
			
			// Button: Easy
			p.rect(PIECE_SPACING, PIECE_SPACING + 130, BOARD_WIDTH - (PIECE_SPACING * 2), 40);
			
			p.fill(0, 0, 0);
			p.textSize(16);
			p.text("Easy", (BOARD_WIDTH - p.textWidth("Easy")) / 2, PIECE_SPACING + 25 + 130);
			
			// Button: Medium
			p.fill(255, 255, 255);
			p.rect(PIECE_SPACING, PIECE_SPACING + 180, BOARD_WIDTH - (PIECE_SPACING * 2), 40);
			
			p.fill(0, 0, 0);
			p.textSize(16);
			p.text("Medium", (BOARD_WIDTH - p.textWidth("Medium")) / 2, PIECE_SPACING + 25 + 180);
			
			// Button: Hard
			p.fill(255, 255, 255);
			p.rect(PIECE_SPACING, PIECE_SPACING + 230, BOARD_WIDTH - (PIECE_SPACING * 2), 40);
			
			p.fill(0, 0, 0);
			p.textSize(16);
			p.text("Hard", (BOARD_WIDTH - p.textWidth("Hard")) / 2, PIECE_SPACING + 25 + 230);
		}
		else if(gameState === GAME_STATE_PLAYING || gameState === GAME_STATE_FINISHING)
		{	
			p.textSize(24);
			
			p.text("Player " + playersTurn + "'s Turn", PIECE_SPACING, 25);
			
			p.textSize(64);
			
			for(let rowIndex = 0; rowIndex < 3; rowIndex++)
			{
				for(let columnIndex = 0; columnIndex < 3; columnIndex++)
				{
					let tilePosition = getTilePosition(rowIndex, columnIndex);
					
					p.fill(255, 255, 255);
					p.rect(tilePosition[0], tilePosition[1], PIECE_WIDTH, PIECE_HEIGHT);
					
					p.fill(0, 0, 0);
					p.text(boardPieces[rowIndex][columnIndex], tilePosition[0] + (PIECE_TEXT_SIZE / 2), tilePosition[1] + PIECE_TEXT_SIZE + 5);
				}
			}
			
			if(gameState === GAME_STATE_FINISHING)
			{
				p.stroke(255, 0, 0);
				p.strokeWeight(10);
				
				let winningEndpoints = getWinningEndpoints();
				
				let startTilePosition = getTilePosition(winningEndpoints[0][0], winningEndpoints[0][1]);
				startTilePosition[0] += (PIECE_WIDTH / 2);
				startTilePosition[1] += (PIECE_HEIGHT / 2);
				
				let endTilePosition = getTilePosition(winningEndpoints[1][0], winningEndpoints[1][1]);
				endTilePosition[0] += (PIECE_WIDTH / 2);
				endTilePosition[1] += (PIECE_HEIGHT / 2);
				
				let difference = [endTilePosition[0] - startTilePosition[0], endTilePosition[1] - startTilePosition[1]];
				
				//line(startTilePosition[0] + (PIECE_WIDTH / 2), startTilePosition[1] + (PIECE_HEIGHT / 2), (endTilePosition[0] + (PIECE_WIDTH / 2)) * (animationStart / (animationStart + ANIMATION_TIME)), (endTilePosition[1] + (PIECE_HEIGHT / 2)) * (animationStart / (animationStart + ANIMATION_TIME)));
				
				let ratio = Math.min(((p.millis() - animationStart)) / ANIMATION_TIME, 1);
				
				p.line(
						startTilePosition[0],
						startTilePosition[1],
						parseInt((startTilePosition[0] + (difference[0] * ratio)), 10),
						parseInt((startTilePosition[1] + (difference[1] * ratio)), 10)
					);
				
				if(p.millis() > animationStart + ANIMATION_TIME + ANIMATION_BUFFER)
				{
					gameState = GAME_STATE_FINISHED;
				}
			}
		}
		else if(gameState === GAME_STATE_FINISHED)
		{
			p.textSize(32);
			
			let winnerText;
			
			if(gameWinner === PLAYER_TIE)
			{
				winnerText = "Nobody wins!";
			}
			else
			{
				winnerText = "Player " + gameWinner + " wins!";
			}
			
			p.text(winnerText, (BOARD_WIDTH - p.textWidth(winnerText)) / 2, 35);
			
			// Button: Play Again
			p.rect(PIECE_SPACING, TITLE_HEIGHT + 20, BOARD_WIDTH - (PIECE_SPACING * 2), 40);
			
			p.fill(0, 0, 0);
			p.textSize(16);
			p.text("Play Again", (BOARD_WIDTH - p.textWidth("Play Again")) / 2, TITLE_HEIGHT + 20 + 25);
		}
	};

	p.mousePressed = function()
	{
		if(gameState === GAME_STATE_MENU)
		{
			if(isMouseWithinRectangle(PIECE_SPACING, PIECE_SPACING + (PIECE_SPACING + 25) + 10, BOARD_WIDTH - (PIECE_SPACING * 2), 40)) // Button: Play
			{
				gameState = GAME_STATE_PLAYING;
				aiDifficulty = AI_NONE;
			}
			else if(isMouseWithinRectangle(PIECE_SPACING, PIECE_SPACING + 130, BOARD_WIDTH - (PIECE_SPACING * 2), 40)) // Button: Easy
			{
				gameState = GAME_STATE_PLAYING;
				aiDifficulty = AI_DIFFICULTY_EASY;
			}
			else if(isMouseWithinRectangle(PIECE_SPACING, PIECE_SPACING + 180, BOARD_WIDTH - (PIECE_SPACING * 2), 40)) // Button: Medium
			{
				gameState = GAME_STATE_PLAYING;
				aiDifficulty = AI_DIFFICULTY_MEDIUM;
			}
			else if(isMouseWithinRectangle(PIECE_SPACING, PIECE_SPACING + 240, BOARD_WIDTH - (PIECE_SPACING * 2), 40)) // Button: Hard
			{
				gameState = GAME_STATE_PLAYING;
				aiDifficulty = AI_DIFFICULTY_HARD;
			}
		}
		else if(gameState === GAME_STATE_PLAYING)
		{
			let selectedTile = getSelectedTile();
			
			if(selectedTile[0] !== -1)
			{
				placePiece(selectedTile);
			}
		}
		else if(gameState === GAME_STATE_FINISHED)
		{
			let topLeftX = PIECE_SPACING;
			let topLeftY = TITLE_HEIGHT + 20;
			
			if(isMouseWithinRectangle(topLeftX, topLeftY, BOARD_WIDTH - (PIECE_SPACING * 2), 40))
			{
				p.setup();
			}
		}
	};

	function placePiece(tile)
	{
		boardPieces[tile[0]][tile[1]] = BOARD_PIECES[playersTurn - 1];
		
		let winner = getWinner(boardPieces);
		
		if(winner === -1)
		{
			if(gameState === GAME_STATE_PLAYING)
			{
				currentTurn++;

				if(currentTurn === 9)
				{
					gameWinner = PLAYER_TIE;
					gameState = GAME_STATE_FINISHED;
				}
				else
				{
					if(playersTurn === PLAYER_ONE)
					{
						playersTurn = PLAYER_TWO;
						
						if(aiDifficulty !== AI_NONE)
						{
							processAIMove();
						}
					}
					else
					{
						playersTurn = PLAYER_ONE;
					}
				}
			}
		}
		else
		{
			gameWinner = winner;
			gameState = GAME_STATE_FINISHING;
			animationStart = p.millis();
		}
	}

	function processAIMove()
	{
		let selectedTile = [0, 0];
		
		if(aiDifficulty === AI_DIFFICULTY_EASY)
		{
			let duplicate = false;
			
			do
			{
				duplicate = false;
				
				selectedTile[0] = parseInt(Math.random() * 3, 10);
				selectedTile[1] = parseInt(Math.random() * 3, 10);
				
				if(boardPieces[selectedTile[0]][selectedTile[1]] !== ' ')
				{
					duplicate = true;
				}
			}
			while(duplicate);
		}
		else if(aiDifficulty === AI_DIFFICULTY_MEDIUM)
		{
			if(Math.random() < 0.5) // 50% chance to pick the correct move
			{
				selectedTile = getCorrectMove();
			}
			else
			{
				let duplicate = false;
				
				do
				{
					duplicate = false;
					
					selectedTile[0] = parseInt(Math.random() * 3, 10);
					selectedTile[1] = parseInt(Math.random() * 3, 10);
					
					if(boardPieces[selectedTile[0]][selectedTile[1]] !== ' ')
					{
						duplicate = true;
					}
				}
				while(duplicate);
			}
		}
		else if(aiDifficulty === AI_DIFFICULTY_HARD)
		{
			selectedTile = getCorrectMove();
		}
		
		placePiece(selectedTile);
	}

	function isMouseWithinRectangle(x, y, width, height)
	{
		return (p.mouseX >= x && p.mouseX <= (x + width) && p.mouseY >= y && p.mouseY <= (y + height));
	}

	function getSelectedTile()
	{
		for(let rowIndex = 0; rowIndex < 3; rowIndex++)
		{
			for(let columnIndex = 0; columnIndex < 3; columnIndex++)
			{
				if(boardPieces[rowIndex][columnIndex] === ' ')
				{
					let tilePosition = getTilePosition(rowIndex, columnIndex);
					
					if(isMouseWithinRectangle(tilePosition[0], tilePosition[1], PIECE_WIDTH, PIECE_HEIGHT))
					{
						return [rowIndex, columnIndex];
					}
				}
			}
		}
		
		return [-1, -1];
	}

	function getWinner(board)
	{
		for(let rowIndex = 0; rowIndex < 3; rowIndex++)
		{
			for(let columnIndex = 0; columnIndex < 3; columnIndex++)
			{
				let currentPiece = board[rowIndex][columnIndex];
				//console.log(currentPiece, board, rowIndex, columnIndex);
				if(currentPiece !== ' ') // Check if a piece is there
				{
					if((columnIndex === 0 && ((currentPiece === board[rowIndex][columnIndex + 1] && currentPiece === board[rowIndex][columnIndex + 2]) || (rowIndex === 0 && currentPiece === board[rowIndex + 1][columnIndex + 1] && currentPiece === board[rowIndex + 2][columnIndex + 2]) || (rowIndex === 2 && currentPiece === board[rowIndex - 1][columnIndex + 1] && currentPiece === board[rowIndex - 2][columnIndex + 2])))
					|| (rowIndex === 0 && currentPiece === board[rowIndex + 1][columnIndex] && currentPiece === board[rowIndex + 2][columnIndex]))
					{
						if(currentPiece === 'X') return PLAYER_ONE;
						else return PLAYER_TWO;
					}
				}
			}
		}
		
		return -1;
	}

	function getWinningEndpoints()
	{
		for(let rowIndex = 0; rowIndex < 3; rowIndex++)
		{
			for(let columnIndex = 0; columnIndex < 3; columnIndex++)
			{
				let currentPiece = boardPieces[rowIndex][columnIndex];
				
				if(currentPiece !== ' ') // Check if a piece is there
				{
					if(columnIndex === 0)
					{
						if(currentPiece === boardPieces[rowIndex][columnIndex + 1] && currentPiece === boardPieces[rowIndex][columnIndex + 2])
						{
							return [[rowIndex, columnIndex], [rowIndex, columnIndex + 2]];
						}
						else if(rowIndex === 0 && currentPiece === boardPieces[rowIndex + 1][columnIndex + 1] && currentPiece === boardPieces[rowIndex + 2][columnIndex + 2])
						{
							return [[rowIndex, columnIndex], [rowIndex + 2, columnIndex + 2]];
						}
						else if(rowIndex === 2 && currentPiece === boardPieces[rowIndex - 1][columnIndex + 1] && currentPiece === boardPieces[rowIndex - 2][columnIndex + 2])
						{
							return [[rowIndex, columnIndex], [rowIndex - 2, columnIndex + 2]];
						}
					}
					
					if(rowIndex === 0 && currentPiece === boardPieces[rowIndex + 1][columnIndex] && currentPiece === boardPieces[rowIndex + 2][columnIndex])
					{
						return [[rowIndex, columnIndex], [rowIndex + 2, columnIndex]];
					}
				}
			}
		}
		
		return [[0, 0], [0, 0]];
	}

	function getTilePosition(row, column)
	{
		return [(column * (PIECE_WIDTH + PIECE_SPACING)) + PIECE_SPACING, (row * (PIECE_HEIGHT + PIECE_SPACING)) + PIECE_SPACING + TITLE_HEIGHT];
	}

	function copyBoard(board)
	{
		let newBoard = [[], [], []];
		
		for(let rowIndex = 0; rowIndex < 3; rowIndex++)
		{
			for(let columnIndex = 0; columnIndex < 3; columnIndex++)
			{
				newBoard[rowIndex][columnIndex] = board[rowIndex][columnIndex];
			}
		}
		
		return newBoard;
	}

	function getBoardScore(board)
	{
		let winner = getWinner(board);
		
		if(winner === PLAYER_ONE)
		{
			return 1;
		}
		else if(winner === PLAYER_TWO)
		{
			return -1;
		}
		
		return 0;
	}

	function isDraw(board)
	{
		let winner = getWinner(board);
		
		if(winner === PLAYER_ONE)
		{
			return false;
		}
		else if(winner === PLAYER_TWO)
		{
			return false;
		}
		
		for(let rowIndex = 0; rowIndex < 3; rowIndex++)
		{
			for(let columnIndex = 0; columnIndex < 3; columnIndex++)
			{
				if(board[rowIndex][columnIndex] === ' ')
				{
					return false;
				}
			}
		}
		
		return true;
	}

	function getNextTurn(turn)
	{
		if(turn === PLAYER_ONE)
		{
			return PLAYER_TWO;
		}
		else
		{
			return PLAYER_ONE;
		}
	}

	function getCorrectMove()
	{
		let board = minimax(boardPieces, playersTurn).board;
		
		for(let rowIndex = 0; rowIndex < 3; rowIndex++)
		{
			for(let columnIndex = 0; columnIndex < 3; columnIndex++)
			{
				if(boardPieces[rowIndex][columnIndex] !== board[rowIndex][columnIndex])
				{
					return [rowIndex, columnIndex];
				}
			}
		}
		
		return [0, 0];
	}

	function getValidBoards(board, turn)
	{
		let validBoards = [];
		let tempBoard = copyBoard(board);
		
		for(let rowIndex = 0; rowIndex < 3; rowIndex++)
		{
			for(let columnIndex = 0; columnIndex < 3; columnIndex++)
			{
				if(tempBoard[rowIndex][columnIndex] === ' ')
				{
					tempBoard[rowIndex][columnIndex] = BOARD_PIECES[turn - 1];
					validBoards.push(tempBoard);
					
					tempBoard = copyBoard(board);
				}
			}
		}
		
		return validBoards;
	}

	class ScoredBoard
	{
		constructor(board, score)
		{
			this.board = board;
			this.score = score;
		}
	}

	// eslint-disable-next-line
	let minimaxTest;
	function minimax(board, turn)
	{
		let boardScore = getBoardScore(board);
		
		if(boardScore !== 0 || isDraw(board))
		{
			return new ScoredBoard(board, boardScore);
		}
		
		let scoredBoards = [];
		let validBoards = getValidBoards(board, turn);
		//console.log(validBoards);

		for(let i = 0; i < validBoards.length; i++)
		{
			let currentBoard = validBoards[i];
			boardScore = getBoardScore(currentBoard);
			
			if(boardScore === 1 && playersTurn === PLAYER_ONE)
			{
				minimaxTest = currentBoard;
				return new ScoredBoard(currentBoard, boardScore);
			}
			else if(boardScore === -1 && playersTurn === PLAYER_TWO)
			{
				minimaxTest = currentBoard;
				return new ScoredBoard(currentBoard, boardScore);
			}
			
			scoredBoards.push(new ScoredBoard(currentBoard, minimax(currentBoard, getNextTurn(turn)).score));	
		}
		
		if(turn === PLAYER_ONE) // Player
		{
			let highestScore = scoredBoards[0].score;
			let highestScoreIndex = 0;
			
			for(let boardIndex = 1; boardIndex < scoredBoards.length; boardIndex++)
			{
				if(scoredBoards[boardIndex].score > highestScore)
				{
					highestScore = scoredBoards[boardIndex].score;
					highestScoreIndex = boardIndex;
				}
			}
			
			minimaxTest = scoredBoards[highestScoreIndex].board;

			return scoredBoards[highestScoreIndex];
		}
		else // AI
		{
			let lowestScore = scoredBoards[0].score;
			let lowestScoreIndex = 0;
			
			for(let boardIndex = 1; boardIndex < scoredBoards.length; boardIndex++)
			{
				if(scoredBoards[boardIndex].score < lowestScore)
				{
					lowestScore = scoredBoards[boardIndex].score;
					lowestScoreIndex = boardIndex;
				}
			}
			
			minimaxTest = scoredBoards[lowestScoreIndex].board;

			return scoredBoards[lowestScoreIndex];
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/TicTacToe/Game.js